var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7501 2.75H3.25008C2.24175 2.75 1.41675 3.575 1.41675 4.58333V15.5833C1.41675 16.5917 2.24175 17.4167 3.25008 17.4167H7.83341V19.25H15.1667V17.4167H19.7501C20.7584 17.4167 21.5742 16.5917 21.5742 15.5833L21.5834 4.58333C21.5834 3.575 20.7584 2.75 19.7501 2.75ZM19.7501 15.5833H3.25008V4.58333H19.7501V15.5833Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequests);
export default __webpack_public_path__ + "static/media/requests.6ae7280f70d22a9d3477e897532bdd13.svg";
export { ForwardRef as ReactComponent };